export const flags = {
  ["en"]: "us",
  ["en-GB"]: "gb",
  ["zh-CN"]: "cn",
  ["zh-TW"]: "tw",
  ["vi"]: "vn",
  ["es"]: "es",
  ["de"]: "de",
  ["ko"]: "kr",
  ["fr"]: "fr",
  ["pt-PT"]: "pt",
  ["pt-BR"]: "br",
  ["pl"]: "pl",
  ["nl"]: "nl",
};

export const languages = [
  { label: "English", locale: "en" },
  { label: "English (UK)", locale: "en-GB" },
  { label: "中文 (简体)", locale: "zh-CN" },
  { label: "中文 (繁體)", locale: "zh-TW" },
  { label: "Tiếng Việt", locale: "vi" },
  { label: "Español", locale: "es" },
  { label: "Deutsch", locale: "de" },
  { label: "한국어", locale: "ko" },
  { label: "Français", locale: "fr" },
  { label: "Português (Portugal)", locale: "pt-PT" },
  { label: "Português (Brasil)", locale: "pt-BR" },
  { label: "Polski", locale: "pl" },
  { label: "Nederlands", locale: "nl" },
];
